import {
    getAsync,
    postAsync,
    putAsync,
    deleteAsync
} from "../helpers/apiHelper";

const endpoint = process.env.VUE_APP_BACKEND + "/api/ExperienceLevel";

// Get all Experience Levels for a discipline
export async function getExperienceLevelForDisciplineAsync(disciplineId) {
  return await getAsync(`${endpoint}/getAllForDiscipline/${disciplineId}`);
}

// Create an Experience Level for a Discipline
export async function createExperienceLevelForDisciplineAsync(disciplineId, model) {
  return await postAsync(`${endpoint}/${disciplineId}`, model);
}

// Update an Experience Level
export async function updateExperienceLevelAsync(model) {
  return await putAsync(`${endpoint}/${model.id}`, model);
}

// Delete an Experience Level
export async function deleteExperienceLevelAsync(Id) {
  return await deleteAsync(`${endpoint}/${Id}`);
}